import { CompetentionsCircles } from './CompetentionsCircles';

export default CompetentionsCircles;